<template>
  <v-container fluid style="height: 100%;" class="box" align-stretch>
    <v-layout row wrap ma-0 py-4 justify-start>
      <v-flex xs12>
        <p class="font-weight-medium my-0 mx-3 px-3">อุบัติเหตุบนโครงข่ายทางน้ำ</p>
        <v-data-table
          :headers="accidentHeader"
          :items="accidentData"
          :items-per-page="10"
          :footer-props="footerProps"
          no-data-text="ไม่พบข้อมูล"
          class="no-new-line-header elevation-0 mt-4 mx-3 px-3"
          :hide-default-footer="accidentData.length == 0"
          :mobile-breakpoint="0"
        >
          <template v-slot:item="props">
            <tr class="cursor" @click="goToPage(props.item.id)">
              <td class="no-new-line">{{ props.index + 1 }}</td>
              <td class="no-new-line">{{ props.item.date }}</td>
              <td class="no-new-line">{{ props.item.time }}</td>
              <td class="no-new-line min-width-250">{{ props.item.location || '-' }}</td>
              <td class="no-new-line">{{ props.item.watertype || '-' }}</td>
              <td class="no-new-line">{{ props.item.cause || '-' }}</td>
              <td class="no-new-line max-width-500">{{ props.item.process || '-' }}</td>
              <td class="no-new-line max-width-100">{{ props.item.use_type || '-' }}</td>
              <td class="no-new-line">{{ props.item.dead }}</td>
              <td class="no-new-line">{{ props.item.injury }}</td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: 'AccidentTable',
  props: {
    searchCondition: {
      type: Object
    }
  },
  data: () => ({
    footerProps: {
      // itemsPerPageOptions: [5, 10, 25, { text: 'ทั้งหมด', value: -1 }],
      itemsPerPageOptions: [],
      itemsPerPageText: 'จำนวนแถวที่แสดง',
      disableItemsPerPage: true
    },
    accidentHeader: [
      { text: 'ลำดับที่', align: 'center', sortable: false, value: 'no' },
      { text: 'วันที่', align: 'center', sortable: false, value: 'date' },
      { text: 'เวลา', align: 'center', sortable: false, value: 'time' },
      {
        text: 'สถานที่เกิดเหตุ',
        align: 'center',
        sortable: false,
        value: 'area'
      },
      {
        text: 'ประเภทสถานที่',
        align: 'center',
        sortable: false,
        value: 'watertype'
      },
      { text: 'สาเหตุ', align: 'center', sortable: false, value: 'cause' },
      {
        text: 'การดำเนินการในเบื้องต้น',
        align: 'center',
        sortable: false,
        value: 'first_operation',
        width: 350
      },
      { 
        text: 'ลักษณะการใช้งาน',
        align: 'center',
        sortable: false,
        value: 'use_type',
        width: 100
      },
      {
        text: 'ผู้เสียชีวิต (คน)',
        align: 'center',
        sortable: false,
        value: 'dead'
      },
      {
        text: 'ผู้บาดเจ็บ (คน)',
        align: 'center',
        sortable: false,
        value: 'injure'
      }
    ],
    accidentData: []
  }),
  mounted() {},
  methods: {
    getAccident() {
      const scope = this;
      const url = `${process.env.VUE_APP_SERVICE_API_URL}/service/get/md_accident`;
      this.axios
        .get(url, { params: this.searchCondition })
        .then(response => {
          if (response.status == 200 && response.data.data) {
            scope.accidentData = response.data.data;
          }
        })
        .catch(function(error) {
          scope.accidentData = [];
          console.log(error);
        });
    },
    goToPage(id) {
      if (id != null) {
        const routeData = this.$router.resolve({ name: 'report_detail', query: { data: id } });
        window.open(routeData.href, '_blank');
      }
    }
  },
  computed: {},
  watch: {
    searchCondition() {
      this.getAccident();
    }
  }
};
</script>

<style lang="scss" scoped>
.class-on-data-table table {
  table-layout: fixed;
}
.container {
  padding: 0;
  background-color: white;
}

.col {
  padding: 0;
}

.v-tab {
  background-color: white;
  color: #ba4438;
}

.v-tab.v-tab--active {
  background-color: #ba4438;
  color: white;
}

.search {
  float: right;
}

.detail {
  background: var(--v-brightgrey-base);
}

.number {
  color: #ba4438;
}

.chart {
  margin-top: 10px;
  margin-bottom: 10px;
}

.sub-menu {
  width: 32px;
  height: 32px;
  margin: auto;
  top: calc(50% - 16px);
}

.rectangle1 {
  min-width: 135px;
  height: 250px;
  border-radius: 3px;
  border: solid 1px #979797;
}

.rectangle2 {
  width: 100%;
  height: 280px;
  border-radius: 3px;
  border: solid 1px #979797;
}

.charts {
  height: 150px;
}

.charts-pie {
  height: 260px;
}

.min-width-250 {
  min-width: 250px;
}
.max-width-100 {
  max-width: 100px;
  // overflow-x : auto;
  white-space: normal !important;
}
.max-width-500 {
  max-width: 500px;
  // overflow-x : auto;
  white-space: normal !important;
}
</style>
